





















































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import {
	SelectableServiceLogDTO,
	ServiceInvoice,
	ServiceRecordDTO
} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import {prettyEnum} from "@/utils/StringUtils";
import InvoiceDTO, {InvoiceItem} from "@/dto/InvoiceDTO";

@Component({
	methods: {prettyEnum},
	components: {SingleFileHolder, BTPortalCollapse}
})
export default class InvoiceCollapse extends Vue {

	@Prop()
	private invoice!: InvoiceDTO<InvoiceItem>

	get invoiceDate(): string {
		return moment(this.invoice.invoiceDate).format("DD.MM.yyyy")
	}

	get statusColor(): string {
		switch (this.invoice.status) {
			case "DRAFT":
			case "PENDING_PAYMENT":
				return "#818181"
			case "COMPLETED": return "#3ECB7F"
			case "VOIDED": return "#E14C44"
			default: return ""
		}
	}

	get total(): string {
		return this.invoice!.total!.toLocaleString("en-US", { minimumFractionDigits: 2 })
	}

	openLog(log: ServiceRecordDTO) {
		this.$emit("log", log)
	}
	private formatDate(date: Date): string {
		return moment(date).format("MMM D");
	}

}
